import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import update from 'immutability-helper';
import Feedbacks from '../common/Feedbacks';
import { postRequest, putRequest } from '../../requestUtils';
import { sendConfirmationEmail } from '../../userUtils';
import './ProjectFeedbacks.scss';

const renderAddCoworkersLink = () => (
  <a
    className="add-coworkers-feedback-link"
    role="button"
    onClick={() => ($('.add-coworkers-button').click())}
    tabIndex={0}
  >
    <br />
    <i className="fas fa-plus" />
    {' '}
    Add Coworkers
  </a>
);

class ProjectFeedbacks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.canComment,
      note: '',
      feedback: props.feedback,
      feedbacks: props.feedbacks,
    };
    this.showComments = this.showComments.bind(this);
    this.handleUpdateFeedback = this.handleUpdateFeedback.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  showComments() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  handleInputChange(event) {
    const { target } = event;
    this.setState({ note: target.value });
  }

  handleUpdateFeedback(feedback, note) {
    const { feedbacks } = this.state;
    const feedbackIndex = feedbacks.findIndex((f) => f.id === feedback.id);
    const newFeedbacks = update(feedbacks, { [feedbackIndex]: { $merge: { note } } });
    this.setState({ feedbacks: newFeedbacks });
  }

  handleSubmit() {
    const { note, feedback, feedbacks } = this.state;
    const { resourceId, csrfToken, email } = this.props;
    if (feedback) {
      putRequest(
        `/projects/${resourceId}/project_feedbacks/${feedback.id}`,
        { project_feedback: { note } },
        csrfToken,
      ).then((response) => {
        const newFeedbacks = update(feedbacks, { $push: [response.data] });
        this.setState({ feedbacks: newFeedbacks, feedback: null, note: '' });
      });
    } else {
      postRequest(
        `/projects/${resourceId}/project_feedbacks`,
        { project_feedback: { email, note } },
        csrfToken,
      ).then((response) => {
        const recentIndex = feedbacks.findIndex((f) => f.most_recent === true);
        let newFeedbacks;
        if (recentIndex > -1) {
          newFeedbacks = update(feedbacks, { [recentIndex]: { most_recent: { $set: false } } });
        } else {
          newFeedbacks = feedbacks;
        }
        newFeedbacks = update(newFeedbacks, { $push: [response.data] });
        this.setState({ feedbacks: newFeedbacks, note: '' });
      });
    }
  }

  handleSendReminder(email, event) {
    const { csrfToken, emailShareUrl } = this.props;
    const { target } = event;
    postRequest(
      emailShareUrl,
      { email },
      csrfToken,
    ).then(() => {
      target.replaceWith(' Sent!');
    });
  }

  renderUnconfirmed() {
    const {
      canInvite, confirmEmailUrl, email, csrfToken,
    } = this.props;
    const message = canInvite
      ? 'Confirm your email to share this project!'
      : 'Confirm your email to comment on this project.';

    return (
      <div className="project-feedbacks-container box-shadow-1 unconfirmed body-text-3">
        <i className="fa fa-exclamation-triangle" />
        <div>
          {message}
          {' '}
          <a
            tabIndex={0}
            role="button"
            className="medium-weight"
            onClick={(e) => sendConfirmationEmail(e, confirmEmailUrl, email, csrfToken, 'Project Show')}
          >
            (Resend confirmation email)
          </a>
        </div>
      </div>
    );
  }

  render() {
    const {
      csrfToken,
      resource,
      resourceId,
      emailShareUrl,
      email,
      unconfirmed,
      canInvite,
      canComment,
    } = this.props;
    const {
      note, feedbacks, feedback, isExpanded,
    } = this.state;

    return (
      <div>
        {canComment && unconfirmed && this.renderUnconfirmed()}
        <div className="project-feedbacks-container
                        box-shadow-1 style-guide"
        >
          <div>
            <a
              className="g-row--always g-row--between expand-link"
              tabIndex={0}
              role="link"
              onClick={() => this.showComments()}
            >
              <h2 className="comments-header bold">Comments on this project</h2>
              <i
                className={`end fa ${isExpanded ? 'fa-caret-up' : 'fa-caret-down'}`}
                role="button"
                tabIndex={0}
                onClick={() => this.showComments()}
              />
            </a>
          </div>

          <div className={`comments-and-colleagues-collapsible ${isExpanded ? 'show' : 'hide'}`}>
            <p className="body-text-2 mt-8 mb-3">
              Comments are only available until Clora starts vetting candidates.
            </p>
            {isExpanded && feedbacks.length > 0
              && (
              <Feedbacks
                feedbacks={feedbacks}
                canCreateFeedback={!unconfirmed && canComment}
                csrfToken={csrfToken}
                resource={resource}
                resourceId={resourceId}
                emailShareUrl={emailShareUrl}
                handleUpdateFeedback={this.handleUpdateFeedback}
                email={email}
              />
              )}
            {canComment
              && (
              <form>
                <div className="fs-hide">
                  <label className="fs-hide body-text-3 demibold" htmlFor="note">
                    {feedbacks.length > 0 && feedbacks[feedbacks.length - 1].email === email ? null : 'You'}
                  </label>
                  <TextareaAutosize
                    id="note"
                    className="form-control fs-hide body-text-3 note"
                    placeholder="Add a comment..."
                    value={feedback ? feedback.note : note}
                    onChange={(e) => this.handleInputChange(e)}
                    rows={1}
                    required={false}
                    disabled={unconfirmed}
                  />
                </div>
                <div className="g-row g-row-justify-right">
                  <button
                    className={`btn btn-primary add-project-comment mt-2 ${note === '' && 'hidden'}`}
                    type="button"
                    onClick={() => this.handleSubmit()}
                  >
                    Send
                  </button>
                </div>
              </form>
              )}
            <div className="colleagues">
              {canInvite && renderAddCoworkersLink()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProjectFeedbacks.propTypes = {
  canComment: PropTypes.bool.isRequired,
  unconfirmed: PropTypes.bool,
  canInvite: PropTypes.bool.isRequired,
  csrfToken: PropTypes.string,
  resourceId: PropTypes.string,
  resource: PropTypes.string.isRequired,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  feedback: PropTypes.shape({}),
  emailShareUrl: PropTypes.string,
  confirmEmailUrl: PropTypes.string,
  email: PropTypes.string,
};

ProjectFeedbacks.defaultProps = {
  unconfirmed: false,
  csrfToken: '',
  resourceId: '',
  feedback: null,
  emailShareUrl: '',
  confirmEmailUrl: '',
  email: '',
};

export default ProjectFeedbacks;
